import { SET_GENERAL_INFORMATION } from '../../Types/ProfileDetails';

export const setGeneralInformation = (payload) => ({
  type: SET_GENERAL_INFORMATION,
  payload,
});
